jQuery(document).ready(function($) {

    $( ".bloc_arguments" ).each(function( index ) {

        var parent = $(this).find(".arguments")
        var cibleArgs = parent.find(".argument")

        gsap.from( cibleArgs, {
            y : +200,
            duration: 1,
            stagger: .2,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 80%",
                end: "top 30%",
                scrub: 1,
            }

        })

        var cibleCentre = parent.find(".centre")

        gsap.from( cibleCentre, {
            rotation : 180,
            duration: 1,
            ease: "power2.out",
            scrollTrigger: {
                trigger: parent,
                markers: false,
                start: "top 100%",
                end: "top 30%",
                scrub: 1,
            }

        })


    })

});